import React, { PropTypes } from 'react'

import Form from "react-jsonschema-form";
import ValueWithUnit from "./ValueWithUnit"
import ValmetSchemaField from "./ValmetSchemaField"
import ObjectField from "./ObjectField"
import MultiField from "./MultiField"
import ValmetFieldTemplateContainer from "../containers/ValmetFieldTemplateContainer"
import CommentWidget from "./CommentWidget";

const log = (type) => console.log.bind(console, type);

/*
const CommentWidget = (props) => {
  return (
    <textarea type="text"
      className="custom"
      value={props.value}
      required={props.required}
      onChange={(event) => props.onChange(event.target.value)} />
  );
};
*/

const fields = {
  valueWithUnit: ValueWithUnit,
  SchemaField: ValmetSchemaField,
  ObjectField: ObjectField,
  multiField: MultiField
};

const widgets = {
  commentWidget: CommentWidget
}

const Page = ({ page, onChange, onSectionChange, onSave, onCancel, isChanged, selectedPage, totalPages, conversionTable }) => (
  <Form schema={page.schema}
        uiSchema={page.uiSchema}
        formData={page.formData}
        liveValidate={true}
  	    autocomplete="off"
        fields={fields}
        widgets={widgets}
        onChange={onChange}
        onSubmit={log("submitted")}
        showErrorList={false}
        onError={log("errors")}
        FieldTemplate={ValmetFieldTemplateContainer}>

      <div className="row">
        <div className="col-md-12">
          <button type="button" className={selectedPage === 1?"hidden":"" +"btn btn-navigation nav-previous"} aria-label="Left Align" onClick={() => onSectionChange(selectedPage - 1)}>
            <span className="glyphicon glyphicon-menu-left" aria-hidden="true"></span>
            Previous section
          </button> &nbsp;

          <button type="button" className="btn btn-navigation nav-next" aria-label="Left Align" onClick={() => onSectionChange(selectedPage + 1)}>
            {selectedPage === totalPages ? "Complete survey" : null}
            {selectedPage < totalPages ? "Next section" : null}
            <span className="glyphicon glyphicon-menu-right" aria-hidden="true"></span>
          </button>
          { isChanged ? 
          <button type="button" className="btn btn-navigation nav-save-cancel" aria-label="Right Align" onClick={() => onSave(selectedPage)}>
            Save</button> :
          <button disabled type="button" className="btn btn-navigation nav-save-cancel" aria-label="Right Align" onClick={() => onSave(selectedPage)}>
            Save</button>}

          <button type="button" className={isChanged ? "btn btn-navigation nav-save-cancel" : "hidden btn btn-navigation nav-save-cancel"} aria-label="Right Align" onClick={() => onCancel(selectedPage)}>
            Cancel
          </button>
          <p></p>
        </div>
      </div>
  </Form>
)

Page.propTypes = {
  page: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
}

export default Page;


// WEBPACK FOOTER //
// ./src/components/Page.js